import { fetchOnemapLocationSearch, type OnemapSearchResult } from '../services/api';

export type OneMapSearchResult = OnemapSearchResult;

export function formatOnemapLocationLabel(result: OneMapSearchResult): string {
  const parts = [
    result.BUILDING && result.BUILDING !== 'NIL' ? result.BUILDING : '',
    result.BLK_NO,
    result.ROAD_NAME,
  ].filter(Boolean);
  const head = parts.join(' ').trim();
  const tail = result.POSTAL && result.POSTAL !== 'NIL' ? ` (${result.POSTAL})` : '';
  return (head || result.SEARCHVAL || result.ADDRESS || '').trim() + tail;
}

export async function searchOnemapLocations(query: string): Promise<OneMapSearchResult[]> {
  return fetchOnemapLocationSearch(query);
}

export function parseOnemapCoordinates(result: OneMapSearchResult): { lat: number; lng: number } | null {
  const lat = Number(result.LATITUDE);
  const lng = Number(result.LONGITUDE);
  if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
  return { lat, lng };
}
